// Pledge, purchase side (Chris, 2026-10-23): a pledged purchase is paid FROM the
// pledge bank. The server decides (invoicing.bank_account_rules); these helpers
// only let the Payment Run screen follow it so nobody ticks their way into a refusal.

/** {bankKey: bankName} for the ticked rows that carry a pledge. */
export const pledgesOfRows = (rows) => {
  const found = new Map();
  (rows || []).forEach((row) => {
    if (row && row.pledge && row.pledge.key) found.set(row.pledge.key, row.pledge.name || row.pledge.key);
  });
  return found;
};

/** The pay-from accounts the ticked rows allow: all of them, or the pledge bank's only. */
export const accountsForPledges = (accounts, pledges) => {
  const list = accounts || [];
  if (!pledges || pledges.size !== 1) return list;
  const [key] = pledges.keys();
  return list.filter((account) => account.bank_key === key);
};

/** Sentences that stop the run, in words. Empty when the ticks are fine. */
export const pledgeBlockers = (pledges, allowedAccounts, companyName = 'the company') => {
  if (!pledges || pledges.size === 0) return [];
  if (pledges.size > 1) {
    return [`The ticked invoices are pledged to different banks (${[...pledges.values()].sort().join(', ')}). Pay each bank's invoices on a run of their own.`];
  }
  const [name] = pledges.values();
  if ((allowedAccounts || []).length === 0) {
    return [`These invoices are pledged to ${name}, but ${companyName} has no ${name} account on file in CRM.`];
  }
  return [];
};

/** "Pledged to DBS Bank: only DBS Bank accounts can pay." for the pay-from hint, or ''. */
export const pledgeHint = (pledges) => {
  if (!pledges || pledges.size !== 1) return '';
  const [name] = pledges.values();
  return `Pledged to ${name}: only ${name} accounts can pay.`;
};
